import {remCalc} from '_themeUtils'

interface StyleProps {
    isAtTop: boolean
}

const accessibilityBanner = {
    AccessibilityBanner: {
        baseStyle: ({isAtTop}: StyleProps) => ({
            wrapper: {
                display: isAtTop ? 'flex' : 'none',
                justifyContent: 'flex-end',
                px: 'spacing.6',
                bg: 'color.background.accessibility.default',
            },
            link: {
                color: 'color.text.black',
                fontWeight: 400,
                fontSize: remCalc(12),
                letterSpacing: remCalc(0.6),
                py: 'spacing.2',
                textTransform: 'none',
                width: 'auto',
                textAlign: {
                    base: 'center',
                    md: 'right',
                },
                margin: {
                    base: '0 auto',
                    md: '0',
                },
            },
        }),
    },
}

export default accessibilityBanner
